import {AbstractAudioParamParameter} from './AbstractAudioParamParameter.js';
import Tone from 'tone';

// todo: change to frequency parameter
const TIME_OPTIONS = [
    {value: '1n', label:'1'},
    {value: '2n', label:'1/2'},
    {value: '4n', label:'1/4'},
    {value: '4t', label:'1/4t'},
    {value: '8n', label:'1/8'},
    {value: '8n.', label:'1/8.'},
    {value: '8t', label:'1/8t'},
    {value: '16n', label:'1/16'},
    {value: '16t', label:'1/16t'},
    {value: '32n', label:'1/32'}
];
 
class RateParameter extends AbstractAudioParamParameter {
    constructor(name, audioParam, setter, config={}) {
        super(name, audioParam, setter, config);
    }

    toSeconds(depth=0, force=false) {
        return new Tone.Time(this.get(force, depth)).toSeconds();
    }

    toFrequency() {
        return new Tone.Time(this.get()).toFrequency();
    }

    toString() {
        return new Tone.Time(this.get()).toString();
    }

    quantize(time) {
        // find closest
        time = new Tone.Frequency(time);
        let minDistance = 100000;
        let minTime = undefined;
        for (let i in TIME_OPTIONS) {
            let option = new Tone.Time(TIME_OPTIONS[i].value);
            let distance = Math.abs(option.toFrequency() - time.toFrequency());
            if (distance < minDistance) {
                minDistance = distance;
                minTime = option;
            }
        }
        return minTime;
    }
}

export default RateParameter;
